import React from "react";

export const NotFound = () => {
  return (
    <div className="container mainContainer">
      <h1 className="title">Página não encontrada.</h1>
    </div>
  );
};
